import { PropsWithChildren } from 'react'

import { OrbitronText, Text } from '../common/Text'

export const Title: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <OrbitronText as="h4" className="text-sm xl:text-xl">
      {children}
    </OrbitronText>
  )
}

export const SubTitle: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <OrbitronText as="h6" className="text-xs xl:text-base">
      {children}
    </OrbitronText>
  )
}

export const Description: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <Text className="text-xs leading-tight xl:text-base" variant="tertiary">
      {children}
    </Text>
  )
}
